
// EACH REFILL — quantity + pickup pace + the as-needed flag (#656 comment 2,
// Dien's prescriptions screenshots). Shared by the searched-drug card
// (MedDetailPanel.vue) and the manual add/edit forms (MedicationsStep.vue).
// v-model contract: { quantity, months: 1|2|3|6|12|'rarely', asNeeded } —
// see parts/medications.js (refillToStored/refillFromStored) for how it
// maps onto the persisted Drug fields.
import { REFILL_MONTHS, refillLabel } from './medications'

export default {
    props: {
        value: { type: Object, required: true },
        // The counting word between the quantity and the pace ("30 tablets,
        // picked up every month") — medications.js's unitWordForForm().
        unit: { type: String, default: 'units' },
    },
    computed: {
        // The as-needed wording is an estimate ("refilled about every…"),
        // not a schedule, and only that mode offers the rarely option.
        monthOptions () {
            if (this.value.asNeeded) {
                return [
                    ...REFILL_MONTHS.map(m => ({
                        value: m,
                        label: m === 1 ? 'refilled about every month' : `about every ${m} months`,
                    })),
                    { value: 'rarely', label: 'rarely: keep on file, leave out of estimates' },
                ]
            }
            return REFILL_MONTHS.map(m => ({
                value: m,
                label: m === 1 ? 'picked up every month' : `every ${m} months`,
            }))
        },
        pricingLine () {
            if (this.value.months === 'rarely') {
                return 'Kept on file: left out of your cost estimates.'
            }
            return `Pricing as ${refillLabel(this.value, this.unit)}: the same numbers Medicare.gov uses.`
        },
    },
    methods: {
        patch (deltas) { this.$emit('input', { ...this.value, ...deltas }) },
        onMonths (raw) {
            this.patch({ months: raw === 'rarely' ? 'rarely' : Number(raw) })
        },
        setAsNeeded (checked) {
            // 'rarely' only exists in as-needed mode; unchecking while on it
            // would leave the select holding an option it no longer offers.
            const deltas = { asNeeded: checked }
            if (!checked && this.value.months === 'rarely') { deltas.months = 1 }
            this.patch(deltas)
        },
    },
}
